var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVegetarian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.28 10C6.8 8 4.42 9.06 5 12.68a11.12 11.12 0 0 0 1 3.11c.25.39 1 .22.89-.27-.42-1.19-1.07-3.87-.61-5.52Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.87 18.5a7.32 7.32 0 0 0 2.47 0c.92-.4.87-.71-.11-.95a10.09 10.09 0 0 1-3.2-.28 11.43 11.43 0 0 1-2.82-1.14c-.37 0-.86.35-.38.71.77.98 2.84 1.46 4.04 1.66Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.37 7.21c0-.77-.61-.89-1 0a8.31 8.31 0 0 0 .41 5 .49.49 0 0 0 .84-.36 29.62 29.62 0 0 1-.25-4.64Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 5.14a.36.36 0 0 0-.72 0C19.12 10.21 9.41 15.09 5 17c-2.5 1.16-4.84 4.51-3.51 6.81a.32.32 0 0 0 .56-.3c-1-1.93 1.21-4.68 3.37-5.53C18.55 12.62 20 7.23 20 5.14Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.31 10.22a20.46 20.46 0 0 1-2.93.88c-.95.36-.92.81-.4 1a5.08 5.08 0 0 0 3.52-1.12c.36-.43.12-.79-.19-.76Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 1.71C21.49 1.26 21.3.27 20.56 0c-1.15-.36-1.59 1.62-2 2C14.21 6.82 6.51 4.11 3 9.17a7.62 7.62 0 0 0-1.47 6.14c.14.72.42 2.21 1.1 2.1a.32.32 0 0 0 .26-.36 6.16 6.16 0 0 1-.57-4.78A8.65 8.65 0 0 1 3.7 9.65C7.06 5 14.7 8 19.47 2.89c.22-.24.51-1 .82-1.44.14.16.27.62.42.87 1.36 2.31 1.05 7 .54 9.49-.77 3.67-2 5.13-4.35 7.53a8.82 8.82 0 0 1-6.63 2.35c-3.07 0-3.18-.92-3.9-1.6a.36.36 0 0 0-.5.53 4 4 0 0 0 2.66 1.73 14.06 14.06 0 0 0 5.62-.35c3.22-1 7-4.78 8.21-10 .56-2.41 1.02-7.53-.61-10.29Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegetarian);
export default __webpack_public_path__ + "static/media/vegetarian.7d67cb190b8d4fa42e08662f9ddf6b09.svg";
export { ForwardRef as ReactComponent };